import { useEffect, useRef } from "react";
import epirocLogo from "@/assets/client-logos/epiroc-logo.webp.asset.json";
import nilfiskLogo from "@/assets/client-logos/nilfisk_wordmark_cmyk_dark.png.asset.json";
import autostoreLogo from "@/assets/client-logos/autostore.png.asset.json";
import massChallengeLogo from "@/assets/client-logos/MassChallenge_Logo.jpg.asset.json";
import startupbootcampLogo from "@/assets/client-logos/Startupbootcamp.png.asset.json";
import aiForgeLogo from "@/assets/client-logos/AI-forge-1.webp.asset.json";
import nbtLogo from "@/assets/client-logos/nbt_logo_alt.svg.asset.json";
import flashpointLogo from "@/assets/client-logos/flashpoint-venture.webp.asset.json";
import lvlupLogo from "@/assets/client-logos/lvlup-ventures.png.asset.json";
import alchemistLogo from "@/assets/client-logos/alchemist-accelerator-logo.jpeg.asset.json";

const TrustedBy = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId: number;
    let isPaused = false;

    const animate = () => {
      if (!isPaused && scrollContainer) {
        scrollContainer.scrollLeft += 0.5;
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        }
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationId);
  }, []);

  const clients = [
    { name: "Epiroc", logo: epirocLogo.url },
    { name: "Nilfisk", logo: nilfiskLogo.url },
    { name: "Autostore", logo: autostoreLogo.url },
    { name: "MassChallenge", logo: massChallengeLogo.url },
    { name: "Startupbootcamp", logo: startupbootcampLogo.url },
    { name: "AI Forge", logo: aiForgeLogo.url },
    { name: "NBT", logo: nbtLogo.url },
    { name: "Flashpoint Venture", logo: flashpointLogo.url },
    { name: "LvlUp Ventures", logo: lvlupLogo.url },
    { name: "Alchemist Accelerator", logo: alchemistLogo.url },
  ];

  return (
    <section className="py-6 border-b border-border/30">
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto">
        <p className="text-xs uppercase tracking-widest text-muted-foreground text-center mb-4">
          Trusted by industry leaders
        </p>
        <div
          ref={scrollRef}
          className="flex overflow-x-hidden select-none [&::-webkit-scrollbar]:hidden"
          style={{ scrollbarWidth: "none" }}
        >
          <div className="flex items-center gap-10 shrink-0">
            {[...clients, ...clients].map((client, i) => (
              <img
                key={`${client.name}-${i}`}
                src={client.logo}
                alt={`${client.name} logo`}
                className="h-8 w-auto max-w-[120px] object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
